import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, Empregador } from '../api.service';
import { ServicoTenant } from '../core/tenant/servico-tenant';

@Injectable({ providedIn: 'root' })
export class ServicoTenantShell {
  constructor(
    private readonly api: ApiService,
    private readonly servicoTenant: ServicoTenant
  ) {}

  buscarTenantPublico(): Observable<Empregador> {
    return this.api.buscarTenantPublico();
  }

  deveCarregarIdentidadeTenantLogin() {
    return !this.servicoTenant.ehHostAdministrativoGlobal();
  }
}
